import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-request-access-error-dialog',
  templateUrl: './request-access-error-dialog.component.html',
  styleUrls: ['./request-access-error-dialog.component.scss']
})
export class RequestAccessErrorDialogComponent implements OnInit {
  constructor(private readonly dialogRef: MatDialogRef<RequestAccessErrorDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {}
}
